import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47249334"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-chamada" }
const _hoisted_2 = { class: "container-site conteudo-chamada" }
const _hoisted_3 = { class: "texto-chamada" }
const _hoisted_4 = { class: "titulo-chamada" }
const _hoisted_5 = { class: "subtitulo-chamada" }
const _hoisted_6 = ["title"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  width: "22",
  height: "22",
  fill: "none",
  stroke: "#FFF212",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M21 11.5a8.5 8.5 0 0 1-12.6 7.4L3 20l1.2-5.1A8.5 8.5 0 1 1 21 11.5z" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.Titulo), 1),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.SubTitulo), 1)
      ]),
      _createElementVNode("button", {
        class: "botao-chamada",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.abrirWhatsApp())),
        title: _ctx.TextoWhatsApp
      }, [
        _hoisted_7,
        _createTextVNode(" Chamar no WhatsApp ")
      ], 8, _hoisted_6)
    ])
  ]))
}